// extracted by mini-css-extract-plugin
module.exports = {"document":"PvD03Z","page":"_3SRu-N","value-control":"_3TPOfK"};